import UIkit from 'uikit';
const initAnimations = () => {
  const overlappedCardSections = document.querySelectorAll('.overlapped-cards');

  if (overlappedCardSections.length > 0) {
    overlappedCardSections.forEach(el => {
      const existingInstance = UIkit.scrollspy(el);
      if (existingInstance) {
        existingInstance.$destroy();
      }

      UIkit.scrollspy(el, {
        target: '> .new-card',
        cls: 'overlapped-card-animation',
        repeat: true,
        delay: 240,
      });
    });
  }

  const sections = document.querySelectorAll(
    '.expandable-cards, .cards-group-wrapper'
  );

  sections.forEach(initSlideFromLeftAnimation);

  function initSlideFromLeftAnimation(el) {
    const instance = UIkit.scrollspy(el);

    if (instance) {
      instance.$destroy();
    }

    UIkit.scrollspy(el, {
      target: '> .new-card',
      cls: 'slide-from-left-animation',
      repeat: false,
      delay: 100,
    });
  }

  const hotspotFadeInAnimationWrappers = document.querySelectorAll(
    '.hotspots-fade-in-animation'
  );

  hotspotFadeInAnimationWrappers.forEach(wrapper => {
    const video = wrapper.querySelector('video');
    const hotspots = wrapper.querySelectorAll('.hotspot');

    if (video) {
      video.addEventListener('ended', () => {
        hotspots.forEach(hotspot => {
          hotspot.style.opacity = '1';
        });
      });
    }
  });

  const hotspots = document.querySelectorAll('.hotspots-animation-wrapper');

  if (hotspots.length > 0) {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -200px 0px',
      threshold: 0,
    };

    const animateHotspots = wrapper => {
      const hotspotElements = wrapper.querySelectorAll('.hotspot');

      hotspotElements.forEach((hotspot, index) => {
        setTimeout(() => {
          hotspot.style.transition =
            'top 0.3s ease, left 0.3s ease, opacity 0.3s ease';
          hotspot.style.top = hotspot.dataset.finalTop;
          hotspot.style.left = hotspot.dataset.finalLeft;
          hotspot.style.opacity = 1;
        }, index * 300);
      });
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateHotspots(entry.target);
        } else if (entry.target.dataset.repeat === 'true') {
          // Optional reset for repeat: true
          const hotspotsOut = entry.target.querySelectorAll('.hotspot');
          hotspotsOut.forEach(h => {
            h.style.transition = 'none';
            h.style.top = '0%';
            h.style.left = '50%';
            h.style.opacity = 0;
          });
        }
      });
    }, observerOptions);

    hotspots.forEach(wrapper => {
      const hotspotElements = wrapper.querySelectorAll('.hotspot');

      hotspotElements.forEach(hotspot => {
        // Store final position and reset initial
        hotspot.dataset.finalTop = hotspot.style.top;
        hotspot.dataset.finalLeft = hotspot.style.left;
        hotspot.style.top = '0%';
        hotspot.style.left = '50%';
        hotspot.style.opacity = 0;
        hotspot.style.position = 'absolute';
      });

      wrapper.dataset.repeat = 'false';

      observer.observe(wrapper);
    });
  }

  const mediaBackgroundSections = document.querySelectorAll(
    '.media-background-section'
  );

  if (mediaBackgroundSections.length > 0) {
    mediaBackgroundSections.forEach(section => {
      const text = section.querySelector('.uk-container');
      UIkit.scrollspy(text, {
        cls: 'slide-from-bottom-animation',
        repeat: false,
      });
    });
  }

  const slideFromLeftElements = document.querySelectorAll('.slide-from-left');

  if (slideFromLeftElements.length > 0) {
    slideFromLeftElements.forEach(el => {
      UIkit.scrollspy(el, {
        cls: 'slide-from-left-animation',
        repeat: false,
      });
    });
  }

  const slideFromRightElements = document.querySelectorAll('.slide-from-right');

  if (slideFromRightElements.length > 0) {
    slideFromRightElements.forEach(el => {
      UIkit.scrollspy(el, {
        cls: 'slide-from-right-animation',
        repeat: false,
      });
    });
  }

  const slideFromBottomElements =
    document.querySelectorAll('.slide-from-bottom');

  if (slideFromBottomElements.length > 0) {
    slideFromBottomElements.forEach(el => {
      UIkit.scrollspy(el, {
        cls: 'slide-from-bottom-animation',
        repeat: false,
      });
    });
  }

  const slideOpacityElements = document.querySelectorAll('.slide-opacity');

  if (slideOpacityElements.length > 0) {
    slideOpacityElements.forEach(el => {
      UIkit.scrollspy(el, {
        cls: 'opacity-animation',
        repeat: false,
      });
    });
  }

  const accordionCards = document.querySelectorAll('.accordion-card');

  if (accordionCards.length > 0) {
    accordionCards.forEach(accordionCard => {
      UIkit.scrollspy(accordionCard, {
        cls: 'opacity-animation',
        repeat: false,
      });
    });
  }
};

export default initAnimations;
